import countries from 'i18n-iso-countries';
// eslint-disable-next-line @typescript-eslint/no-var-requires
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));

export function getAllCountriesByLang (lang = 'de') {
  return countries.getNames(lang, { select: 'official' });
}
